import { render, staticRenderFns } from "./OurBeliefs.vue?vue&type=template&id=29f4f064"
import script from "./OurBeliefs.vue?vue&type=script&lang=ts"
export * from "./OurBeliefs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports